import { ErrorHandler, Injectable, Injector } from "@angular/core";
import { AlertService, MessageSeverity } from './services/alert.service';
import { AuthService } from "./services/auth.service";

@Injectable()
export class AppErrorHandler extends ErrorHandler {
    private alertService: AlertService;
    private authService: AuthService;

    constructor(private injector: Injector) {
        super();
    }

    handleError(error: any) {
        // OLD CODE
        //// if (this.alertService == null) {
        ////    this.alertService = this.injector.get(AlertService);
        //// }
        //// this.alertService.showStickyMessage("Fatal Error!", "An unresolved error has occured. Please reload the page to correct this error", MessageSeverity.warn);
        //// this.alertService.showStickyMessage("Unhandled Error", error.message || error, MessageSeverity.error, error);

        // if (confirm("Fatal Error!\nAn unresolved error has occured. Do you want to reload the page to correct this?\n\nError: " + error.message))
        //    window.location.reload(true);
        // super.handleError(error);

        // NEW CODE
        if (this.alertService == null) {
            this.alertService = this.injector.get(AlertService);
        }
        if (this.authService == null) {
            this.authService = this.injector.get(AuthService);
        }

        if (error.status === 401) {
            this.alertService.showMessage("Niet-geautoriseerde gebruiker", "U hebt geen rechten op toegang tot deze bron, Neem contact op met de beheerder voor meer informatie.", MessageSeverity.error);
            this.authService.logout();
            this.authService.redirectLogoutUser();
        } else {
            this.alertService.showMessage("Fatale fout!", "Er is een onopgeloste fout opgetreden. Laad de pagina opnieuw om deze fout te corrigeren", MessageSeverity.warn);
        }

        // if (this.alertService == null) {
        //    this.alertService = this.injector.get(AlertService);
        // }
        // this.alertService.showStickyMessage("Fatal Error!", "An unresolved error has occured. Please reload the page to correct this error", MessageSeverity.warn);
        // this.alertService.showStickyMessage("Unhandled Error", error.message || error, MessageSeverity.error, error);
        // if (confirm("Fatal Error!\nAn unresolved error has occured. Do you want to reload the page to correct this?\n\nError: " + error.message))
        //    window.location.reload(true);
        super.handleError(error);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/app-error.handler.ts